import { TweenMax, Power2 } from 'gsap';

class PromoClose {
  constructor() {
    this.promo = document.querySelector('.promo');
    this.closeButton = document.querySelector('.js--promo-close');
    this.getSessionItem();
  }

  /**
   * Get promo status from session storage
   */
  getSessionItem() {
    const isHidden = sessionStorage.getItem('hidePromo');

    if (!isHidden) {
      this.promo.classList.add('promo--visible');
      this.initialize();
    }
  }

  /**
   * Initialize and bind events
   */
  initialize() {
    this.bindEvents();
  }

  /**
   * Bind event listerners
   */
  bindEvents() {
    this.closeButton.addEventListener('click', this.removeClass.bind(this));
  }

  /**
   * Animates and hides the promo
   */
  removeClass() {
    TweenMax.to('.promo', 0.2, {
      opacity: 0,
      ease: Power2.easeInOut,
      onComplete: () => {
        TweenMax.set('.promo', { display: 'none' });
        this.save();
      },
    });
  }

  /**
   * Save promo status to session storage
   */
  save() {
    sessionStorage.setItem('hidePromo', true);
  }
}

export default PromoClose;
